import { ISnapshot, ISnapshotState, ISnapshotData, ISanpshotInitializer, SnapshotTypes } from '~/interfaces/plugins/snapshot'
import Store from '../store'
import { globalLogger } from '~/plugins/logger'
import { toastInstance } from './toast'
import { i18nInstance } from './localization'
import emptyId from '~/statics/empty-id'
import { isEmpty } from '~/statics/validators'

export default class Snapshot implements ISnapshot {

  form: string
  state: ISnapshotState
  LOCALSTORAGEKEY: string
  retrieveData: () => any
  isDataChanged!: () => Promise<boolean>
  CURRENTFISCALID: string
  CURRENTUSERID: string

  constructor(initializer: () => ISanpshotInitializer, intervalTimeInSeconds: any) {
    this.form = 'Empty Form'
    this.retrieveData = () => null
    this.LOCALSTORAGEKEY = 'nikan-snapshots'
    this.CURRENTFISCALID = emptyId
    this.CURRENTUSERID = emptyId

    this.state = {
      timeInSeconds: intervalTimeInSeconds,
      initialized: false,
      intervalId: 0,
      snapshotsTaken: 0
    }

    if (typeof initializer === 'function') {
      var init = initializer()

      if (init.form)
        this.form = init.form
      else
        throw new Error('Snapshot Initializer Requires a Form!')

      if (init.isDataChanged && typeof init.isDataChanged === 'function')
        this.isDataChanged = init.isDataChanged
      else
        throw new Error('Snapshot Initializer Requires a isDataChanged method!')


      if (init.retrieveData && typeof init.retrieveData === 'function') {
        this.retrieveData = init.retrieveData
        this.setInterval()
      }

    }
  }

  /**
   * takeSnapshot is run intervally by setInterval method and refrence to the parent class will be removed.
   * therefore instance should be passed as a parameter.
   */
  takeSnapshot(type: SnapshotTypes = SnapshotTypes.AUTOMATIC, that: ISnapshot = this): void {

    if (!that.state.initialized)
      throw new Error('Snapshot Is Not Initialized!')

    const take = () => {
      that.addToLocalStorage({ date: new Date().toISOString(), form: that.form, data: that.retrieveData(), type })
      that.state.snapshotsTaken += 1
      globalLogger.log(`${that.form} - ${type} - Snapshot Taken`)
    }

    if (type === SnapshotTypes.MANUAL)
      take()

    else
      that.isDataChanged()
        .then((isChanged: boolean) => {
          if (isChanged)
            take()
          else
            globalLogger.log(`${that.form} - ${type} - Data is not Changed!`)
        })
  }

  restoreSnapshot(type: SnapshotTypes = SnapshotTypes.AUTOMATIC) {
    const local = this.getLocalStorage()

    if (!this.state.initialized || !local.context.length) {
      // @ts-ignore
      return toastInstance(i18nInstance.global.t('snapshot.m.no-data'))
    }

    if (local.fiscalPeriodId !== this.CURRENTFISCALID) {
      globalLogger.error(`${this.form} - ${type} - Availabe Snapshot Isn't For This Fiscal`)
      // @ts-ignore
      toastInstance(i18nInstance.global.t('snapshot.m.is-not-for-this-fiscal'), { type: 'error' })
      return
    }

    if (local.userId !== this.CURRENTUSERID) {
      globalLogger.error(`${this.form} - ${type} - Availabe Snapshot Isn't For This User`)
      // @ts-ignore
      toastInstance(i18nInstance.global.t('snapshot.m.is-not-for-this-user'), { type: 'error' })
      return
    }

    const snapshot = local.context.find((x: ISnapshotData) => x.form === this.form && x.type === type)

    if (snapshot) {
      globalLogger.log(`${this.form} - ${type} - Snapshot Restored!`)
      // @ts-ignore
      toastInstance(i18nInstance.global.t('snapshot.m.restored'), { type: 'success' })
      return snapshot.data
    }
    else
      toastInstance(i18nInstance.global.t('snapshot.m.no-data'))

  }

  addToLocalStorage(data: ISnapshotData) {
    const local = this.getLocalStorage()
    var index = local.context.findIndex((x: ISnapshotData) => x.form === this.form && x.type === data.type)

    if (index > -1)
      local.context[index] = data
    else
      local.context.push(data)

    localStorage.setItem(this.LOCALSTORAGEKEY, JSON.stringify(local))
  }

  getLocalStorage(): any {
    const local = localStorage.getItem(this.LOCALSTORAGEKEY) || ''

    if (!local.length)
      return {
        userId: this.CURRENTUSERID,
        fiscalPeriodId: this.CURRENTFISCALID,
        context: []
      }

    return JSON.parse(local)
  }

  setInterval(): void {

    this.state.initialized = true
    this.CURRENTFISCALID = Store.getters['appContext/getFiscalPeriod'].id
    this.CURRENTUSERID = Store.getters['appContext/getUser'].id
    this.state.intervalId = setInterval(this.takeSnapshot, this.state.timeInSeconds * 1000, SnapshotTypes.AUTOMATIC, this)

    globalLogger.log(`${this.form} - Snapshot Initialized`)
  }

  tryFlush(userId: string, fiscalPeriodId: string): void {
    const local = this.getLocalStorage()
    if ((!isEmpty(local.userId) && local.userId !== userId) || (!isEmpty(local.fiscalPeriodId) && local.fiscalPeriodId !== fiscalPeriodId)) {
      localStorage.removeItem(this.LOCALSTORAGEKEY)
      globalLogger.log('Snapshot Flushed!')
    }
  }

  forceFlush() {
    globalLogger.log('Snapshot Force Flushed!')
    localStorage.removeItem(this.LOCALSTORAGEKEY)
  }

  getState(): ISnapshotState {
    return this.state
  }

  clearInterval(intervalId: number): void {
    globalLogger.log(`${this.form} Snapshot Interval Cleared!, Snapshots taken: ${this.state.snapshotsTaken}`)
    clearInterval(intervalId)
  }

  userHasSnapshot(type: SnapshotTypes): boolean {
    const local = this.getLocalStorage()

    if (this.state.initialized && local.context.length)
      if (local.userId === this.CURRENTUSERID && local.fiscalPeriodId === this.CURRENTFISCALID)
        if (local.context.findIndex((x: ISnapshotData) => x.form === this.form && x.type === type) > -1)
          return true

    return false
  }

}